import { Button } from './style'

export type Props = {
  height?: number
  width?: number
  borderRadius?: number
  onSubmit: (value: any) => void
  children?: string
  margin?: string
}

const GConfirmButton = ({
  height,
  width,
  borderRadius,
  onSubmit,
  children,
  margin,
}: Props) => (
  <Button
    height={height}
    width={width}
    margin={margin}
    borderRadius={borderRadius}
    onClick={onSubmit}
  >
    {children ?? 'OK'}
  </Button>
)

export default GConfirmButton
